import { render, staticRenderFns } from "./loginDia.vue?vue&type=template&id=360424ba&scoped=true&"
import script from "./loginDia.vue?vue&type=script&lang=js&"
export * from "./loginDia.vue?vue&type=script&lang=js&"
import style0 from "./loginDia.vue?vue&type=style&index=0&id=360424ba&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360424ba",
  null
  
)

export default component.exports